import { AssetClassInvestmentType } from "@api/v1/hooks/performance/assetClasses";

// Keeps the investments of the given types; no types keeps everything.
export const filterInvestmentsByType = <T extends { type?: string }>(
  investments: T[],
  investmentTypes: AssetClassInvestmentType[]
): T[] => {
  if (!investmentTypes.length) return investments;
  const types: readonly string[] = investmentTypes;
  return investments.filter(
    (investment) =>
      investment.type !== undefined && types.includes(investment.type)
  );
};
